import { render, staticRenderFns } from "./OrderHafciarnia.vue?vue&type=template&id=02221c6e&"
import script from "./OrderHafciarnia.vue?vue&type=script&lang=js&"
export * from "./OrderHafciarnia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports